import { Component, Vue } from 'vue-property-decorator'
import { Service, Issue } from '@/views/console/moderators-console/moderators-console-types'
@Component

export default class ModeratorsConsole extends Vue {

  private namespace = '/Console';

  private issues = [] as Issue[];

  issuesOpen = false;

  beforeMount () {

    this.getIssues();
  }

  private async getIssues () {
    
    try {
  
      const analytics = await this.$axios.get<Service[]>(`${this.$apiUrl + this.namespace}/InactiveGoogleAnalytic`);
      
      const serpbook = await this.$axios.get<Service[]>(`${this.$apiUrl + this.namespace}/StrangeSerpBook`);
      
      const issues = [] as Issue[];

      analytics.data.forEach( service => issues.push({
        serviceId: service.serviceId,
        domain: service.domain,
        analytics: true,
        serpbook: false
      }));

      serpbook.data.forEach( service => {

        const hasAnalytic = issues.some( issue => {
          if ( issue.serviceId === service.serviceId ) {

            issue.serpbook = true;
            return true;
          }
        });

        if ( !hasAnalytic ) {
          issues.push({
            serviceId: service.serviceId,
            domain: service.domain,
            analytics: false,
            serpbook: true
          });
        }
      });

      this.issues = issues;

    } catch ( error ) {
  
      console.log( error );
    }
  }
}